import React from 'react';
import { Upload, Button, message } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import {
  arrayOf, func, number, oneOfType, shape, string,
} from 'prop-types';
import {
  ACCEPT, ALLOWED_EXTENSIONS, MAX_FILE_SIZE_MB, fileExtension,
} from 'components/attachments/fileValidation';

const isValidFile = (file) => {
  const extension = fileExtension(file);

  if (!extension || !ALLOWED_EXTENSIONS.has(extension)) {
    const formats = [...ALLOWED_EXTENSIONS].join(', ');
    message.error(I18n.t('tickets.form.invalid_file_type', { formats }));
    return false;
  }

  if (file.size / 1024 / 1024 > MAX_FILE_SIZE_MB) {
    // eslint-disable-next-line camelcase
    message.error(I18n.t('errors.messages.size_too_big', { file_size: `${MAX_FILE_SIZE_MB} MB` }));
    return false;
  }

  return true;
};

const CommentAttachmentButton = ({ fileList = [], setFileList = (_files) => {} }) => {
  const addFiles = (_file, files) => {
    const validFiles = files.filter(isValidFile);

    setFileList((prev) => [
      ...prev,
      ...validFiles.filter((file) => prev.every((existing) => existing.uid !== file.uid)),
    ]);

    return Upload.LIST_IGNORE;
  };

  return (
    <Upload
      accept={ACCEPT}
      multiple
      showUploadList={false}
      fileList={fileList}
      beforeUpload={addFiles}
    >
      <Button
        type="text"
        size="small"
        icon={<PaperClipOutlined />}
        className="ticket-comments-form__toolbar-btn"
      >
        {I18n.t('ticket_comments.files')}
      </Button>
    </Upload>
  );
};

CommentAttachmentButton.propTypes = {
  fileList: arrayOf(shape({
    uid: oneOfType([number, string]),
    name: string,
    size: number,
  })),
  setFileList: func,
};

export default CommentAttachmentButton;
